import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertColor } from "@mui/material/Alert";

interface ISnackbarMessage {
  text: string;
  severity: AlertColor;
}

type TSnackbarTrigger = (message: ISnackbarMessage) => void;
const SnackbarContext = React.createContext<TSnackbarTrigger>(() => {
  console.error(
    "Unsupported method. Default SnackbarContext shouldn't be used!",
  );
});

export const SnackbarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [open, setOpen] = React.useState(false);
  const [text, setText] = React.useState<string>("");
  const [severity, setSeverity] = React.useState<AlertColor>("info");

  const showMessage = (message: ISnackbarMessage) => {
    setText(message.text);
    setSeverity(message.severity);
    setOpen(true);
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={showMessage}>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        data-cy="snackbar"
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {text}
        </Alert>
      </Snackbar>
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  return React.useContext(SnackbarContext);
};
